<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="companyInfo"
            :value.sync="currentValue"
            display-expr="고객사코드"
            value-expr="고객사코드"
            content-template="contentTemplate"
            @value-changed="onValueChangedDropBox"
        >
          <template #contentTemplate="{}">
            <dx-data-grid ref='refCompanyGrid'
              :data-source='companyInfo'
              :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
              :selection="{ mode: 'single' }" :hover-state-enabled = "true" :allowColumnResizing = 'true'
              column-resizing-mode = 'widget' :allow-column-reordering = "true"
              :height='gridHeight'
              @selection-changed = "onSelectionChanged"
            >
              <DxSearchPanel
                :visible="true"
                placeholder="검색..."
              />
              <DxFilterRow
                :visible="true"
                apply-filter="auto"
              />
              <DxColumn
                :fixed="true"
                caption="고객사코드"
                data-field="고객사코드"
                width = '70'>
              </DxColumn>

              <DxColumn
                sort-order='asc'
                caption="고객사명"
                data-field="고객사명"
                width = '136'>
              </DxColumn>
              <dx-paging :enabled="false"/>
              <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
              <dx-sorting mode="multiple"/>
            </dx-data-grid>
          </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxDataGrid, { DxScrolling,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxFilterRow } from 'devextreme-vue/data-grid'

import DxDropDownBox from 'devextreme-vue/drop-down-box'
// import ConstDef from '../../ConstDef'
export default {
  name: 'companyGrid',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 300 },
      gridHeight: 300,
      companyInfo: null
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => function (data) {
        // // console.log(data)
      }
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxDropDownBox,
    DxFilterRow
  },
  computed: {
  },
  created () {
    this.refreshCompanyInfo()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onValueChangedDropBox (e) {
      // // console.log(e)
      if (e.value === null) {
        // this.currentValue = e.value
        // this.onValueChanged(this.currentValue)
      }
    },
    onSelectionChanged (e) {
      // // console.log(e.selectedRowsData[0])
      this.currentValue = e.selectedRowsData[0].고객사코드
      this.onValueChanged(e.selectedRowsData[0].고객사코드)
      this.$emit('change-selected', e.selectedRowsData[0])
      this.$refs.dropDownBoxRefName.instance.close()
    },
    refreshCompanyInfo () {
      this.$_sp.runFindSqlProc('고객사정보', null)
        .then(data => {
          this.companyInfo = this.$_sp.MakeModel(data)
        })
    }
  }
}
</script>

<style lang="scss">

</style>
